import makeStyles from '@mui/styles/makeStyles';
import { dispatch_theme } from '@/config/colors';


export const vehicleListStyles = makeStyles((theme: typeof dispatch_theme) => ({
  stickyListHeader: {
    backgroundColor:'white',
    height: 44,
    marginRight:1,
    borderBottom:'1px solid #e5e5e5',
  },
  search: {
    position: 'relative',
    marginRight: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    '&:hover': {
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto'
    }
  },
  searchPadding: {
    margin: theme.spacing(1, 0),
    padding: theme.spacing(0),
    alignItems: 'center',
    display: 'flex'
  },
  inputRoot: {
    color: 'inherit',
    width: '100%'
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    width: '100%'
  },
  clearIcon: {
    cursor: 'pointer'
  },
  action: {
    marginTop: 0,
    marginRight: theme.spacing(2)
  },
  danger: {
    color: theme.palette.error.main
  },
  mergePrompt: {
    padding: theme.spacing(2)
  },
  cardContent: {
    height: window.innerHeight - 244,
    overflowY: 'auto',
    padding: 0
  },
  loadClassList: {
    height: window.innerHeight - 160,
    overflowY: 'auto',
    padding: 0
  },
  bar: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    width: theme.spacing(1)
  },
  listItem: {
    padding: theme.spacing(2)
  },
  notAllowed: {
    cursor: 'not-allowed'
  },
  dialogPaper: {
    borderRadius: 6,
    width: 460,
    maxWidth: '90%',
  },

  titleRoot: {
    padding: '16px 12px 12px 16px',
  },

  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },

  iconWrap: {
    display: 'grid',
    placeItems: 'center',
    flexShrink: 0,
  },

  deleteIcon: {
    color: '#ef5927'
  },

  titleText: {
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '24px',
    color: theme?.palette?.text?.primary || '#111',
    flex: 1,
  },

  closeBtn: {
    padding: 6,
  },

  messageText: {
    fontSize: 14,
    lineHeight: '20px',
    color: theme?.palette?.text?.secondary || '#6b6b6b',
  },

  actionsRoot: {
    padding: '0 16px 16px 16px',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 12,
  },

  cancelBtn: {
    textTransform: 'uppercase',
    fontWeight: 600,
    borderWidth: 1,
    padding: '8px 14px',
  },

  deleteBtn: {
  textTransform: 'uppercase',
  fontWeight: 700,
  padding: '8px 18px',
  backgroundColor: '#ef5927',
  color: '#fff !important',
  boxShadow: 'none',

  '&:hover': {
    backgroundColor: '#ef5927',
    color: '#fff',
  },
},
}));